/**
 * Format the tooltip to be pretty printed into a yaml like format
 */
export function formatTooltip<T>(data?: T, indent?: number) {
  if (!data) return ''

  return Object.entries(data)
    .map(([key, value]) => {
      let formattedValue = value
      if (typeof value === 'object') {
        formattedValue = '\n' + formatTooltip(value, (indent ?? 0) + 2)
      }

      return `${' '.repeat(indent ?? 0)}${key}: ${formattedValue}`
    })
    .join('\n')
}
